import { Card, CardContent, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { commonStyles, styleTokens } from '../../../assets/styles/commonStyles';

// Styled Components using common styles
export const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: '42rem',
    overflowY: 'auto',
    ...commonStyles.enhancedCard(theme),
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
    // Standard card content styling
}));

export const StyledList = styled(List)(({ theme }) => ({
    padding: 0,
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
    paddingY: 0,
    padding: 0,
    margin: 0,
}));

export const StyledListItemButton = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== 'enabled'
})<{ enabled?: boolean }>(({ theme, enabled = true }) => ({
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(0.1),
    minHeight: 'auto',
    transition: styleTokens.transitions.card,
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    color: enabled ? theme.palette.text.primary : theme.palette.text.secondary,
    opacity: enabled ? 1 : 0.6,
    fontWeight: enabled ? 500 : 400,
    
    // Add indentation for child items (nested inside StyledListItem)
    '.MuiListItem-root &': {
        paddingLeft: theme.spacing(4), // Indent child items more
        marginLeft: theme.spacing(2),  // Additional left margin for child items
    },
    
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.05), transparent)',
        transform: 'translateX(-100%)',
        transition: 'transform 0.6s ease-in-out',
    },
    
    '&:hover': {
        backgroundColor: enabled ? 'rgba(25, 118, 210, 0.08)' : 'rgba(0, 0, 0, 0.04)',
        transform: enabled ? styleTokens.transforms.slideRight(2) : 'none',
        boxShadow: enabled ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none',
        
        '&::before': {
            transform: enabled ? 'translateX(100%)' : 'none',
        },
    },
    
    '&.Mui-selected': {
        backgroundColor: styleTokens.colors.primaryAlpha[62],
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        transform: styleTokens.transforms.slideRight(4),
        boxShadow: styleTokens.elevations.listItemSelected,
        color: theme.palette.text.primary,
        opacity: 1,
        
        '&:hover': {
            backgroundColor: styleTokens.colors.primaryAlpha[42],
            transform: styleTokens.transforms.slideRight(6),
            boxShadow: styleTokens.elevations.listItemSelectedHover,
        },
    },
}));

export const StyledListItemText = styled(ListItemText, {
    shouldForwardProp: (prop) => prop !== 'enabled'
})<{ enabled?: boolean }>(({ theme, enabled = true }) => ({
    '& .MuiListItemText-primary': {
        ...commonStyles.responsiveText(theme),
        fontWeight: enabled ? 500 : 400,
        color: enabled ? 'inherit' : theme.palette.text.secondary,
        opacity: enabled ? 1 : 0.7,
    },
}));

export const StyledEmptyStateDiv = styled('div')(({ theme }) => ({
    ...commonStyles.emptyState(theme),
}));
